// extracted by mini-css-extract-plugin
export default {"container":"OurClients_container__LAXGy","clientscontainer":"OurClients_clientscontainer__ON6Kk","image":"OurClients_image__5gjN7"};